module.exports = __webpack_public_path__ + "static/img/kongtiao_gaofeng_active.5805a2b2.png";